import { EUnitOfMeasure } from '../shared/enum';
import { TInputSoil, TSoilInputData } from '../shared/iProject';
import { EUnitOfMeasureImperialLabel, EUnitOfMeasureLabel, EUnitOfMeasureMetricLabel } from './enum';

export const soilType: TInputSoil = 'soilType';
export const layerNumber: TInputSoil = 'layerNumber';
export const frictionAngle: TInputSoil = 'frictionAngle';
export const drainedCohesion: TInputSoil = 'drainedCohesion';
export const undrainedCohesion: TInputSoil = 'undrainedCohesion';
export const unitWeight: TInputSoil = 'unitWeight';
export const saturatedUnitWeight: TInputSoil = 'saturatedUnitWeight';
export const effectivePorosity: TInputSoil = 'effectivePorosity';
export const drainedSoilPermeability: TInputSoil = 'drainedSoilPermeability';
export const remodeledSoilPermeability: TInputSoil = 'remodeledSoilPermeability';
export const permeabilityChangeUponRemodeling: TInputSoil = 'permeabilityChangeUponRemodeling';
export const thickness: TInputSoil = 'thickness';
export const hydraulicConductivity: TInputSoil = 'hydraulicConductivity';

export const soilPD = {
    [soilType]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [layerNumber]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [frictionAngle]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureLabel.deg,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureLabel.deg,
        },
    },
    [drainedCohesion]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.kilonewtonPerSquareMeter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.poundForcePerSquareFoot,
        },
    },
    [undrainedCohesion]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.kilonewtonPerSquareMeter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.poundForcePerSquareFoot,
        },
    },
    [unitWeight]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.kilonewtonPerCubicMeter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.poundForcePerCubicFoot,
        },
    },
    [saturatedUnitWeight]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.kilonewtonPerCubicMeter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.poundForcePerCubicFoot,
        },
    },
    [effectivePorosity]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [drainedSoilPermeability]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meterPerSecond,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.footPerSecond,
        },
    },
    [remodeledSoilPermeability]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meterPerSecond,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.footPerSecond,
        },
    },
    [permeabilityChangeUponRemodeling]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [thickness]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.inch,
        },
    },
    [hydraulicConductivity]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureLabel.perSecond,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureLabel.perSecond,
        },
    },
};

export const id: TSoilInputData = 'id';
export const layersInSeries: TSoilInputData = 'layersInSeries';
export const soils: TSoilInputData = 'soils';

export const soilInputDataPD = {
    [id]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },[layersInSeries]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meterPerSecond,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.footPerSecond,
        },
    },
    [soils]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
};
